import { JobApiService } from './job-api.service';
import JobPublicLinkStatus from '../types/job-public-link-status.type';


interface ResponseDataType {
  status: JobPublicLinkStatus;
  pdf_url: string;
  pdf_id: string;
}

interface RequestParams {
  token: string;
  customerId: string;
  signatures: string[];
  jobIds: string[];
}

export const signAndAcceptJobPreviewRequest = (
  { customerId, token, signatures, jobIds }: RequestParams
): Promise<ResponseDataType> => {
  return JobApiService.makeRequest<ResponseDataType>(`/job/${ customerId }/html/preview/sign-and-accept`, {
    token,
    method: 'POST',
    body: {
      signatures,
      job_ids: jobIds,
    }
  });
};